import { render, staticRenderFns } from "./ordersSortModel.vue?vue&type=template&id=bdcb362e&scoped=true&"
import script from "./ordersSortModel.vue?vue&type=script&lang=js&"
export * from "./ordersSortModel.vue?vue&type=script&lang=js&"
import style0 from "./ordersSortModel.vue?vue&type=style&index=0&id=bdcb362e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcb362e",
  null
  
)

export default component.exports